
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

var $2fbbdc0ca86197ed$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"3jwlv\",\"SpaceSettingsNavigationPortal.e07b388c.js\",\"bU3dV\",\"CopySpacePermissionsAndDefaultPermissions.a27d31b7.js\",\"eMbU0\",\"SpaceSelector.560fac26.js\",\"3wN5D\",\"ExternalSpaceLozenge.11ec98f6.js\",\"kC80R\",\"esm.7399a977.js\",\"h3ABO\",\"esm.dc8ab43b.js\",\"5RR9C\",\"manual-triggers-modal.b84ca746.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.253fecd7.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.3b8ed966.js\",\"7EorR\",\"vendors~editor_atlaskit_md.cdb30309.js\",\"g43Ev\",\"simpleHasher.0f14e142.js\",\"dkgtP\",\"simpleHasher.runtime.b3fc72ae.js\",\"31vk5\",\"main.ef834ad2.js\",\"7cABH\",\"emoji.a921127a.js\",\"2vAWg\",\"emoji.runtime.2ae4c0e4.js\",\"hogcU\",\"component-lazy.c401bc70.js\",\"fGPXi\",\"FullPageEditorComponent.66748d9b.js\",\"lkwGP\",\"FullPageEditorComponent.runtime.e4159584.js\",\"jXx9i\",\"NativeCollabComponent.5e274adb.js\",\"ffEVr\",\"vendors~editor_icon.f597614a.js\",\"9GDly\",\"SpaceSelector.5535e046.js\",\"lJJQ8\",\"ViewChangesDialog.4b1c81e6.js\",\"8OiWl\",\"ChangesDiff.266f7784.js\",\"dtpmo\",\"SpaceSelector.ce8265d6.js\",\"6wr18\",\"vendors~editor_icon.288a0ce9.js\",\"lkwGP\",\"FullPageEditorComponent.runtime.e4159584.js\",\"2vAWg\",\"emoji.runtime.2ae4c0e4.js\",\"dkgtP\",\"simpleHasher.runtime.b3fc72ae.js\",\"4yUSc\",\"PremiumLozenge.6931dbeb.js\",\"ePA5l\",\"Lozenge.4acf06a8.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"1yVM6\",\"UpgradeEditionButton.43ac8edb.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.4d021263.js\",\"5pvpJ\",\"datasourceTableView.686437f9.js\",\"6XCf4\",\"LearnMoreButton.1d2bf46b.js\",\"cEqm7\",\"ShareButton.422725ca.js\",\"hOaAV\",\"ExtensionConfigUpsell.a0323a14.js\",\"7JvFY\",\"CopySpacePermissionsForLegacyNewSpace.d48a057d.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.4d021263.js\",\"9LX74\",\"searchNoResults.7be90ed3.svg\"]"));


$parcel$global.rlb("780Yf")
//# sourceMappingURL=SpaceSettingsNavigationPortal.runtime.47723928.js.map
